import { render, staticRenderFns } from "./RegisterBankForOrderDialog.vue?vue&type=template&id=0af5ed42&scoped=true"
import script from "./RegisterBankForOrderDialog.vue?vue&type=script&lang=js"
export * from "./RegisterBankForOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5ed42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af5ed42')) {
      api.createRecord('0af5ed42', component.options)
    } else {
      api.reload('0af5ed42', component.options)
    }
    module.hot.accept("./RegisterBankForOrderDialog.vue?vue&type=template&id=0af5ed42&scoped=true", function () {
      api.rerender('0af5ed42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/RegisterBankForOrderDialog.vue"
export default component.exports